import {CalendarMod} from './CalendarMod';
import {formatDate} from '../../dates/dates';
import {getTheme} from '@fluentui/react';
import {textColor} from '../../styles';

const theme = getTheme();

export function selectFontColor(
  date: Date,
  todayText: string,
  mod?: CalendarMod,
): string {
  const ymd = formatDate(date);

  if (ymd && mod) {
    const color = mod.dateMap[ymd]?.color;

    if (color) {
      return color;
    }
  }

  if (ymd === todayText) {
    return `rgb(78, 39, 0)`;
  }

  return selectColorByWeekDay(date.getDay());
}

function selectColorByWeekDay(weekDay: number): string {
  switch (weekDay) {
    case 0:
      return theme.palette.red;
    case 6:
      return theme.palette.blueMid;
    default:
      return textColor;
  }
}

export function selectBackgroundColor(
  date: Date,
  todayText: string,
  mod?: CalendarMod,
): string {
  const ymd = formatDate(date);

  if (ymd && mod) {
    const color = mod.dateMap[ymd]?.backgroundColor;

    if (color) {
      return color;
    }
  }

  if (ymd === todayText) {
    return 'rgba(255, 216, 0, 0.15)';
  }

  return selectBackgroundColorByWeekDay(date.getDay());
}

function selectBackgroundColorByWeekDay(weekDay: number): string {
  switch (weekDay) {
    case 0:
      return 'rgba(255, 78, 78, 0.1)';
    case 6:
      return 'rgba(39, 117, 255, 0.1)';
    default:
      return 'transparent';
  }
}
